import { RESET_UNIFIED_FORM } from "../constants/ActionTypes";

export default (state = {}, action = {}) => {
  switch (action.type) {
    case RESET_UNIFIED_FORM:
      return {
        ...state,
        selectedAssets: [],
        showSingleAsset: false,
        singleAsset: {},
        showSingleCustomer: false,
        singleCustomer: {}
      };
    default:
      return state;
  }
};
